import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-modelo-veiculo-edit',
	templateUrl: './modelo-veiculo-edit.component.html',
	styleUrls: ['./modelo-veiculo-edit.component.css'],
	animations: [loadingFade]
})
export class ModeloVeiculoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public modelo_veiculo_id = null;

	public formModeloVeiculo: FormGroup;
	public marca_veiculo_array = [];

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private marcaVeiculoSvc: MarcaVeiculoService,
				private modeloVeiculoSvc: ModeloVeiculoService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.modelo_veiculo_id = params.id;
				// pega dados a partir do id
				this.modeloVeiculoSvc.getModeloVeiculo(params.id).then((data: any) => {
					this.preencheForm({
						modelo_veiculo_id: data.modelo_veiculo_id,
						modelo_veiculo_nome: data.modelo_veiculo_nome,
						marca_veiculo_id: data.marca_veiculo_id
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formModeloVeiculo = this.fb.group({
			modelo_veiculo_id: null,
			modelo_veiculo_nome: ['', Validators.required],
			marca_veiculo_id: [null, Validators.required]
		});

		this.pegaMarcaVeiculos();
	}

	pegaMarcaVeiculos() {
		this.marcaVeiculoSvc.getMarcasVeiculo('marca_veiculo_nome').then((data: any[]) => {
			this.marca_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formModeloVeiculo.setValue(dados);
	}

	enviaModeloVeiculo() {
		if (this.formModeloVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formModeloVeiculo.value;

			if (this.modelo_veiculo_id === null) { // criar
				this.modeloVeiculoSvc.criaModeloVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Modelo criado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/modelosveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.modeloVeiculoSvc.editaModeloVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Modelo alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/modelosveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formModeloVeiculo.controls){
				let campo = this.formModeloVeiculo.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formModeloVeiculo.get(nome);
		return input.touched && input.invalid;
	}
}
